import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const TableSkeleton = () => {
  return (
    <div className="card">
      {/* Header Skeleton */}
      <div className="card-header border-0 pt-5">
        <div className="d-flex align-items-center gap-10">
          <h3 className="card-title align-items-start flex-column">
            <Skeleton width={120} height={24} />
          </h3>
          <div className="d-flex align-items-center gap-3">
            <Skeleton width={250} height={40} />
            <Skeleton width={100} height={40} />
            <Skeleton width={100} height={40} />
          </div>
        </div>
        <div className="card-toolbar">
          <Skeleton width={100} height={40} />
        </div>
      </div>

      {/* Table Skeleton */}
      <div className="card-body py-3">
        <div className="table-responsive">
          <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
            <thead>
              <tr>
                <th className="min-w-100px text-center"><Skeleton width={80} height={20} /></th>
                <th className="min-w-100px text-center"><Skeleton width={80} height={20} /></th>
                <th className="min-w-100px text-center"><Skeleton width={80} height={20} /></th>
                <th className="min-w-100px text-center"><Skeleton width={80} height={20} /></th>
                <th className="min-w-100px text-center"><Skeleton width={80} height={20} /></th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 5 }).map((_, index) => (
                <tr key={index}>
                  <td className="text-center"><Skeleton width={100} height={20} /></td>
                  <td className="text-center"><Skeleton width={100} height={20} /></td>
                  <td className="text-center"><Skeleton width={100} height={20} /></td>
                  <td className="text-center"><Skeleton width={100} height={20} /></td>
                  <td className="text-center d-flex justify-content-center gap-2">
                    <Skeleton circle width={30} height={30} />
                    <Skeleton circle width={30} height={30} />
                    <Skeleton circle width={30} height={30} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination Skeleton */}
      <div className="d-flex align-items-center justify-content-between pb-5 ps-10 pe-5">
        <div className="d-flex align-items-center gap-3">
          <span className="fs-6 text-muted"><Skeleton width={50} height={20} /></span>
          <Skeleton width={60} height={40} />
        </div>
        <Skeleton width={100} height={40} />
      </div>
    </div>
  );
};

export default TableSkeleton;
